<div class="float-drag" cdkDrag>
    <div class="float-container" cdkDragHandle>
        <div class="float-header" >
			<div class="header-text">Line Merge</div>
            <!-- <i class="glyphicons glyphicons-remove" (click)="close()"></i> -->
        </div>

		<!-- <div class="line-merge-title">
            Line Merge
        </div> -->
		<div class="attr-wrap">
			<div class="vertical-item column-labels">
				<div class="hori-unit">
					<div class="attr-cell"></div>
				</div>
				<div class="hori-unit leftright-header">
					<div class="attr-cell"></div>
				</div>
				<div class="hori-unit">
					<div class="attr-cell">{{nguidCol.name}}</div>
				</div>
				<div *ngFor="let col of cols" class="hori-unit">
					<div class="attr-cell">{{col.neutralName}}</div>
				</div>
			</div>
			<!-- <div class="vertical-divider"></div> -->
			<div class="vertical-item selected-line">
				<div class="hori-unit rec-header">
					<div class="attr-cell">
						<select name="selectionList" [(ngModel)]="selectedLine">
							<option *ngFor="let line of selectionList; let idx = index;" [ngValue]="line">Line {{idx + 1}}</option>
						</select>
					</div>
				</div>
				<div class="hori-unit leftright-header">
					<div class="attr-cell">Left</div>
					<div class="attr-cell">Right</div>
				</div>
				<ng-container *ngIf="selectedLine">
					<div class="hori-unit">
						<div class="attr-cell">{{selectedLine[nguidCol.prop]}}</div>
					</div>
					<div *ngFor="let col of cols" class="hori-unit">
						<div class="attr-cell">{{selectedLine[col.leftProp]}}</div>
						<div class="attr-cell">{{selectedLine[col.rightProp]}}</div>
					</div>
					<div class="hori-unit">
						<button (click)="setPrimary()">Set Primary</button>
					</div>
				</ng-container>
			</div>
			<!-- <div class="vertical-divider"></div> -->
			<div class="vertical-item merged-line">
				<div class="hori-unit rec-header">
					<div class="attr-cell">Merged Line</div>
				</div>
				<div class="hori-unit leftright-header">
					<div class="attr-cell">Left</div>
					<div class="attr-cell">Right</div>
				</div>
				<ng-container *ngIf="mergedRec">
					<div class="hori-unit">
						<div class="attr-cell">
							<input name="nguid" [(ngModel)]="mergedRec[nguidCol.prop]">
						</div>
					</div>
					<div *ngFor="let col of cols; let idx = index;" class="hori-unit">
						<div class="attr-cell">
							<input name="left-{{idx}}" [(ngModel)]="mergedRec[col.leftProp]">
						</div>
						<div class="attr-cell">
							<input name="right-{{idx}}" [(ngModel)]="mergedRec[col.rightProp]">
						</div>
					</div>
					<div class="hori-unit">
						<!-- <button>Flip</button> -->
					</div>
				</ng-container>
			</div>
		</div>

        <div class="float-popup-footer">
            <div class="button-groups">
                <button class="button-general" (click)="cancel()">Cancel</button>
                <button class="button-general" (click)="apply()">Apply</button>
            </div>
        </div>



    </div>
</div>